import { arDZ } from "../../../../date-fns/locale/ar-DZ.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    arDZ
  }
};